<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { __ } from 'JIX/gettext.js';

import DsCheckSwitch from 'JIX/components/ds/DsCheckSwitch.vue';

const store = useStore();

const adminMode = computed({
    get: () => store.getters.isAdmin,
    set: (value) => {
        store.commit('setAdmin', value);
        store.dispatch('performSearch');
    },
});

const solrDebug = computed(() => store.state.searchResponse.debug?.solr);

</script>

<template>
    <div>
        <DsCheckSwitch
            v-model="adminMode"
        >
            {{ __('Administratorversion') }}
        </DsCheckSwitch>

        <details class="my-4" v-if="solrDebug">
            <summary>Query debug</summary>

            <div class="bg-surface-default px-3 border">
                <strong>querystring:</strong>
                <div class="mb-3">
                    <code>{{ solrDebug.querystring }}</code>
                </div>

                <strong>parsed_query:</strong>
                <div class="mb-3">
                    <code>{{ solrDebug.parsedquery }}</code>
                </div>

                <strong>filters:</strong>
                <ul>
                    <li
                        v-for="filter, i of solrDebug.filter_queries"
                        :key="i"
                    >
                        <code>{{ filter }}</code>
                    </li>
                </ul>
            </div>
        </details>
    </div>
</template>
